import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Logo from "../assets/artefactly-logo.svg";

const NavbarView = () => {
  return (
    <Nav>
      <LogoContainer>
        <LogoImage src={Logo} alt="Artefactly Logo" />
      </LogoContainer>
      <CenterText>a r t e f a c t l y .</CenterText>
      <NavButtons>
        <NavButton>
          <Link to="/">Home</Link>
        </NavButton>
        <NavButton>
          <Link to="/gallery">Gallery</Link>
        </NavButton>
      </NavButtons>
    </Nav>
  );
};

export default NavbarView;

// Nav: slightly tighter on mobile
const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background-color: black;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 8px 16px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-right: 10px; /* Adjust spacing for smaller screens */
  }
`;

// Logo: a touch smaller on small screens
const LogoImage = styled.img`
  height: 70px;
  width: auto;

  @media (max-width: 768px) {
    height: 36px;
  }
`;

// Center text: use clamp + reduced letter-spacing on mobile
const CenterText = styled.div`
  font-family: "Heiti SC", sans-serif;
  font-weight: bold;
  color: white;
  text-align: center;
  line-height: 1;
  /* Fluid size with sensible bounds */
  font-size: clamp(14px, 1.6vw + 6px, 22px);
  letter-spacing: 0.08em;

  @media (max-width: 768px) {
    font-size: clamp(12px, 2.6vw, 18px);
    letter-spacing: 0.04em;
  }

  /* Optional: hide on ultra-small screens if you want extra room
  @media (max-width: 340px) {
    display: none;
  } */
`;

// Buttons: reduce gap on mobile
const NavButtons = styled.div`
  display: flex;
  gap: 25px;

  @media (max-width: 768px) {
    gap: 14px;
  }
`;

const NavButton = styled.div`
  a {
    font-family: "Heiti SC", sans-serif; /* Set font to Heiti SC */
    color: white;
    text-decoration: none;
    font-weight: bold;
    font-size: 18px;
  }
  a:hover {
    color: red; /* Add hover effect for better UX */
  }

  @media (max-width: 768px) {
    font-size: 16px; /* Adjust font size for smaller screens */
  }
`;
